// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const Formatting = t.struct({
    dateFields: t.list(t.String)
});

export const getDefaultState = () =>
    new Formatting({
        dateFields: [
            'creationDate',
            'changedOn'
        ]
    });

export default Formatting;



// WEBPACK FOOTER //
// ./src/reports/update-machine-status-history/state/formatting.js